'use strict';
const RestUtils = require('utils/RestUtils'),
    apiAppUrl = process.env.URL_API,
    Security = require('./Security').auth,
    get = require('lodash/object').get,
    Constants = require('constants/AppConstants');

const InventoryServiceImpl = {

    getIconByProduct(productId, callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/icons/products/' + productId, true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    getProducts(callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/products', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getFinishProducts(callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/products?state=FINISHED', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getFinishItems(callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/items?category=FINISHED', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getLocation(callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/locations', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getVendor(callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/vendors', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getVendorAddresses(vendorId, callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/vendors/' + vendorId + '/addresses', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getVendorContacts(vendorId, callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/vendors/' + vendorId + '/contacts', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getVendorPurchases(page, callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/vendors/purchases?page=' + page + '&size=' + Constants.MAX_ITEMS_BY_PAGES_ADMINS);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getVendorPurchasesWithTotalPrice(page, callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/vendors/purchases/total-price?page=' + page + '&size=' + Constants.MAX_ITEMS_BY_PAGES_ADMINS);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

   downloadReportXLS(filter, controllerName, success, failure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
                success.bind(this)();
        }, failure);

        ajax.open('POST', apiAppUrl + '/'+controllerName+'/reports' + RestUtils.formatQueryString(filter), true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.responseType = 'arraybuffer';
        ajax.onload = function () {
            if (this.status === 200) {
                var filename = '';
                var disposition = ajax.getResponseHeader('Content-Disposition');
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches !== null && matches[1]) filename = matches[1].replace(/['"]/g, '');
                }
                var type = ajax.getResponseHeader('Content-Type');

                var blob = typeof File === 'function'
                    ? new File([this.response], filename, { type: type })
                    : new Blob([this.response], { type: type });
                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                    // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
                    window.navigator.msSaveBlob(blob, filename);
                } else {
                    var URL = window.URL || window.webkitURL;
                    var downloadUrl = URL.createObjectURL(blob);

                    if (filename) {
                        // use HTML5 a[download] attribute to specify filename
                        var a = document.createElement('a');
                        // safari doesn't support this yet
                        if (typeof a.download === 'undefined') {
                            window.location = downloadUrl;
                        } else {
                            a.href = downloadUrl;
                            a.download = filename;
                            document.body.appendChild(a);
                            a.click();
                        }
                    } else {
                        window.location = downloadUrl;
                    }

                    setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 100); // cleanup
                }
            }
        };
        ajax.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        ajax.send();

    },

    downloadReportPDF(filter, controllerName, success, failure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
                success.bind(this)();
        }, failure);

        ajax.open('POST', apiAppUrl + '/'+controllerName+'/reports' + RestUtils.formatQueryString(filter), true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.responseType = 'arraybuffer';
        ajax.onload = function () {
            if (this.status === 200) {
                var filename = '';
                var disposition = ajax.getResponseHeader('Content-Disposition');
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches !== null && matches[1]) filename = matches[1].replace(/['"]/g, '');
                }
                var type = ajax.getResponseHeader('Content-Type');

                var blob = typeof File === 'function'
                    ? new File([this.response], filename, { type: type })
                    : new Blob([this.response], { type: type });
                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                    // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
                    window.navigator.msSaveBlob(blob, filename);
                } else {
                    var URL = window.URL || window.webkitURL;
                    var downloadUrl = URL.createObjectURL(blob);

                    if (filename) {
                        // use HTML5 a[download] attribute to specify filename
                        var a = document.createElement('a');
                        // safari doesn't support this yet
                        if (typeof a.download === 'undefined') {
                            window.location = downloadUrl;
                        } else {
                            a.href = downloadUrl;
                            a.download = filename;
                            document.body.appendChild(a);
                            a.click();
                        }
                    } else {
                        window.location = downloadUrl;
                    }

                    setTimeout(function () { URL.revokeObjectURL(downloadUrl); }, 100); // cleanup
                }
            }
        };
        ajax.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        ajax.send();

    },

    getVendorPurchasesBy(filter, callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/vendors/purchases/filter' + RestUtils.formatQueryString(filter));
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getSales(page, callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });
        ajax.open('GET', apiAppUrl + '/sales?page=' + page + '&size=' + Constants.MAX_ITEMS_BY_PAGES_ADMINS);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getSalesBy(filter, callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });
        ajax.open('GET', apiAppUrl + '/sales/filter' + RestUtils.formatQueryString(filter));
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getSaleItems(saleId, callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/sales/' + saleId + '/items', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getCustomers(callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/customers', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getCustomerAddresses(customerId, callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/customers/' + customerId + '/addresses', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getCustomerItems(customerId, callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/customers/' + customerId + '/items', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getCustomerContacts(customerId, callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/customers/' + customerId + '/contacts', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getVendorPurchasesItem(vendorId, callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/vendors/' + vendorId + '/purchases-items', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.send();
    },

    getItemsByProduct(productId, isAddition, callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/items/products/' + productId + '?is-addition='+isAddition, true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    getItems(page, callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/items?page=' + page + '&size=' + Constants.MAX_ITEMS_BY_PAGES_ADMINS);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    getNonInventoryItems(callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/items/non-inventory');
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    getAllItems(callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/items/all');
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },


    getItemsBy(filter, callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/items/filter' + RestUtils.formatQueryString(filter));
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    getItemsLocation(pageNumber, callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/locations/items?page=' + pageNumber + '&size=' + Constants.MAX_ITEMS_BY_PAGES_ADMINS);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    getLocationItemsWithTotalAmount(pageNumber, callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/locations/items/total-amount?page=' + pageNumber + '&size=' + Constants.MAX_ITEMS_BY_PAGES_ADMINS);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    getLocationItemsWithTotalAmountBy(filter, callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/locations/items/total-amount/filter' + RestUtils.formatQueryString(filter));
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    getVendorItems(vendorId, callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/vendors/' + vendorId + '/items', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    getIcons(callback) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                callback.bind(this)();
            });
        });

        ajax.open('GET', apiAppUrl + '/icons', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },


    addVendorItem(vendorId, itemId, vendorItem, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/vendors/' + vendorId + '/items/' + itemId, true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(vendorItem));
    },

    addIcon(icon, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/icons', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(icon));
    },

    addVendor(vendor, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/vendors', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(vendor));
    },

    addVendorPurchase(vendorPurchase, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/vendors/purchases', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(vendorPurchase));
    },

    duplicateVendorPurchase(vendorPurchase, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        const purchaseId = get(vendorPurchase, 'purchase.id');

        ajax.open('POST', apiAppUrl + '/vendors/purchases/' + purchaseId + '/duplicate', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },
    markPaidVendorPurchase(vendorPurchaseId, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/vendors/purchases/' + vendorPurchaseId + '/paid', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },
    saveCommentOnlyVendorPurchase(vendorPurchaseId, comment, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/vendors/purchases/' + vendorPurchaseId + '/comment', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(comment);
    },
    addVendorPurchaseItem(vendorPurchaseItem, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/vendors/purchases/items', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(vendorPurchaseItem));
    },

    addSale(sale, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/sales', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(sale));
    },

    addSaleItem(sale, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/sales/'+sale.saleId+'/items', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(sale));
    },

    addCustomer(customer, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/customers', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(customer));
    },

    addCustomerItem(customerId, customerItemId, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/customers/' + customerId + '/items', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(customerItemId));
    },

    addCustomerContact(customerId, customerContact, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/customers/' + customerId + '/contacts', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(customerContact));
    },

    addCustomerAddress(customerId, customerAddress, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/customers/' + customerId + '/addresses', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(customerAddress));
    },

    changeSale(sale, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)(JSON.parse(this.responseText).message);
            });
        });
        
        ajax.open('PUT', apiAppUrl + '/sales', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(sale));
    },

    changeAmountPaidPO(vendorPurchase, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)(JSON.parse(this.responseText).message);
            });
        });

        ajax.open('POST', apiAppUrl + '/vendors/purchases/'+vendorPurchase.id+'/paidMod', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(vendorPurchase));
    },

    changeAmountPaidSO(sale, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)(JSON.parse(this.responseText).message);
            });
        });

        ajax.open('POST', apiAppUrl + '/sales/'+sale.id+'/paidMod', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(sale));
    },

    changeSaleItem(sale, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('PUT', apiAppUrl + '/sales/'+sale.saleId+'/items', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(sale));
    },

    changeCustomer(customer, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('PUT', apiAppUrl + '/customers', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(customer));
    },

    changeCustomerAddress(customerId, customerAddress, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('PUT', apiAppUrl + '/customers/' + customerId + '/addresses', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(customerAddress));
    },

    changeCustomerItems(customerId, customerItemId, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('PUT', apiAppUrl + '/customers/' + customerId + '/items', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(customerItemId));
    },

    changeCustomerContact(customerId, customerContact, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('PUT', apiAppUrl + '/customers/' + customerId + '/contacts', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(customerContact));
    },

    addVendorAddress(vendorId, address, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/vendors/' + vendorId + '/addresses', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(address));
    },

    addVendorContact(vendorId, contact, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/vendors/' + vendorId + '/contacts', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(contact));
    },

    addLocation(location, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/locations', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(location));
    },

    addProduct(product, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/products', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(product));
    },

    duplicateProduct(product, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/products/' + get(product, 'duplicatedId') + '/duplicate', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(product));
    },

    addItem(item, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/items', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(item));
    },

    addProductItem(productId, productItem, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/items/products/' + productId, true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(productItem));
    },

    addLocationItem(locationItem, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        const locationId = get(locationItem, 'locationId');
        const itemId = get(locationItem, 'itemId');

        ajax.open('POST', apiAppUrl + '/locations/' + locationId + '/items/' + itemId, true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(locationItem));
    },

    changeProductItem(productId, productItem, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('PUT', apiAppUrl + '/items/products/' + productId, true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(productItem));
    },

    changeItem(item, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('PUT', apiAppUrl + '/items', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(item));
    },

    changeLocationItem(locationItem, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        const locationId = get(locationItem, 'locationId');
        const itemId = get(locationItem, 'itemId');

        ajax.open('PUT', apiAppUrl + '/locations/' + locationId + '/items/' + itemId, true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(locationItem));
    },

    changeVendorItem(vendorId, itemId, vendorItem, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('PUT', apiAppUrl + '/vendors/' + vendorId + '/items/' + itemId, true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(vendorItem));
    },

    changeVendorPurchase(vendorPurchase, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('PUT', apiAppUrl + '/vendors/purchases', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(vendorPurchase));
    },

    changeVendorPurchaseItem(vendorPurchaseItem, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('PUT', apiAppUrl + '/vendors/purchases/items', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(vendorPurchaseItem));
    },

    changeVendorPurchaseItemReceived(vendorPurchaseItem, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('PUT', apiAppUrl + '/vendors/purchases/items-received', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(vendorPurchaseItem));
    },

    changeVendorPurchaseItemReceivedDraft(vendorPurchaseItem, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('PUT', apiAppUrl + '/vendors/purchases/items-received/draft', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(vendorPurchaseItem));
    },

    changeProduct(product, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('PUT', apiAppUrl + '/products', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(product));
    },

    changeIconFromProduct(productIdSelected, iconsChanged, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('PUT', apiAppUrl + '/icons/products/' + productIdSelected, true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(iconsChanged));
    },

    changeIcon(iconsChanged, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('PUT', apiAppUrl + '/icons', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(iconsChanged));
    },

    changeVendor(vendor, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('PUT', apiAppUrl + '/vendors', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(vendor));
    },

    changeVendorAddress(vendorId, address, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('PUT', apiAppUrl + '/vendors/' + vendorId + '/addresses', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(address));
    },

    changeVendorContact(vendorId, contact, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('PUT', apiAppUrl + '/vendors/' + vendorId + '/contacts', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(contact));
    },

    changeLocation(location, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('PUT', apiAppUrl + '/locations', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(location));
    },

    sendVendorPurchaseOrder(vendorPurchaseId, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)(JSON.parse(this.responseText).message);
            });
        });

        ajax.open('PUT', apiAppUrl + '/vendors/purchases/' + vendorPurchaseId + '/send', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(location));
    },

    sendOrderToCustomer(saleId, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)(JSON.parse(this.responseText).message);
            });
        });

        ajax.open('POST', apiAppUrl + '/sales/' + saleId + '/sendEmail', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    confirmVendorPurchaseOrder(vendorPurchaseId, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)(JSON.parse(this.responseText).message);
            });
        });

        ajax.open('PUT', apiAppUrl + '/vendors/purchases/' + vendorPurchaseId + '/confirm', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(location));
    },

    confirmSaleOrderDelivered(saleId, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)(JSON.parse(this.responseText).message);
            });
        });

        ajax.open('POST', apiAppUrl + '/sales/' + saleId + '/confirm-delivered', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(location));
    },

    saveCommentOnlySaleOrder(saleId, comment, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/sales/' + saleId + '/comment', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(comment);
    },

    markPaidSale(saleId, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        ajax.open('POST', apiAppUrl + '/sales/' + saleId + '/paid', true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    saveTransfer(transferInfo, onSuccess, onFailure) {
        let ajax = RestUtils.createXHR();
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, function () {
                onSuccess.bind(this)();
            }, function () {
                onFailure.bind(this)();
            });
        });

        const locationFromId = get(transferInfo, 'locationFromId');
        const locationToId = get(transferInfo, 'locationToId');
        const itemId = get(transferInfo, 'itemId');

        ajax.open('POST', apiAppUrl + '/locations/items/' + itemId + '/from/' + locationFromId + '/to/' + locationToId, true);
        ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        ajax.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send(JSON.stringify(transferInfo));
    },

    deleteItem(productItemId, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', apiAppUrl + '/items/' + productItemId);
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    deleteSale(saleId, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', apiAppUrl + '/sales/' + saleId);
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    deleteSaleItem(saleId, saleItemId, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', apiAppUrl + '/sales/' + saleId + '/items/' + saleItemId);
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    deleteCustomer(customerId, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', apiAppUrl + '/customers/' + customerId);
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    deleteCustomerContact(customerId, customerContactId,  success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', apiAppUrl + '/customers/' + customerId + '/contacts/' + customerContactId);
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    deleteCustomerAddress(customerId, customerAddressId, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', apiAppUrl + '/customers/' + customerId + '/addresses/' + customerAddressId);
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    deleteCustomerItems(customerId, customerItemId, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', apiAppUrl + '/customers/' + customerId + '/items/' + customerItemId);
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    deleteLocationItem(locationItemId, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', apiAppUrl + '/locations/items/' + locationItemId);
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    deleteLocation(locationId, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', apiAppUrl + '/locations/' + locationId);
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    deleteVendor(vendorId, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', apiAppUrl + '/vendors/' + vendorId);
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    deleteVendorAddress(vendorId, addressesId, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', apiAppUrl + '/vendors/' + vendorId + '/addresses/' + addressesId);
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    deleteVendorContact(vendorId, contactId, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', apiAppUrl + '/vendors/' + vendorId + '/contacts/' + contactId);
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    deleteVendorItem(vendorId, itemId, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', apiAppUrl + '/vendors/' + vendorId + '/items/' + itemId);
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    deleteProduct(productId, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', apiAppUrl + '/products/' + productId);
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    deletePurchase(purchaseId, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', apiAppUrl + '/vendors/purchases/' + purchaseId);
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    deletePurchaseItem(vendorPurchaseItemId, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', apiAppUrl + '/vendors/purchase-items/' + vendorPurchaseItemId);
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    },

    deleteProductItem(productItemId, success, failure) {
        var ajax = RestUtils.createXHR();
        ajax.addEventListener('error', failure);
        ajax.addEventListener('load', function () {
            RestUtils.handlerResponse(this, success, failure);
        });
        ajax.open('DELETE', apiAppUrl + '/items/products/' + productItemId);
        ajax.setRequestHeader(Constants.TOKEN_AUTH_CUSTOM_HEADER, Security.getToken());
        ajax.setRequestHeader(Constants.APPLICANT_ID_CUSTOM_HEADER, Security.getCurrentApplicantId());
        ajax.send();
    }
};


module.exports = InventoryServiceImpl;



/** WEBPACK FOOTER **
 ** ./src/services/InventoryServiceImpl.js
 **/